<template>
  <flex
    direction="column"
    justify="center"
    align="center"
    class="search-image-uploader">
    <flex
      id="uploadBox"
      direction="column"
      justify="center"
      align="center"
      class="upload-box"
      @click="upload"
      @dragenter="handleDragenter"
      @dragover="handleDragover"
      @drop="handleDrop">
      <span
        v-if="!uploadImage"
        class="upload-text">
        点击上传
      </span>
      <span
        v-if="!uploadImage"
        class="upload-tips">
        拖拽图片到这里
      </span>
      <!-- <span
        v-else
        class="upload-tips">
        {{ uploadImage.name }}
      </span> -->
      <img
        v-else
        :src="uploadImage"
        class="upload-image">
    </flex>
    <input
      id="upload"
      type="file"
      style="display: none"
      @change="uploadSearchImage($event, 'click')">
    <flex
      justify="center">
      <span
        class="submit-text"
        @click="submitSearchUpload">
        确认
      </span>
      <span
        class="submit-text clear"
        @click="clearSearchImage">
        清除
      </span>
    </flex>
  </flex>
</template>

<script>
export default {
  data () {
    return {
      formData: '',
      uploadImage: ''
    }
  },
  mounted () {
    this.$root.eventHub.$on('get-image-form', () => {
      this.searchByImage()
    })
  },
  destroyed () {
    this.$root.eventHub.$off('get-image-form')
  },
  methods: {
    // 点击上传文件
    upload () {
      document.getElementById('upload').click()
    },
    // 用户上传了图片文件
    uploadSearchImage (event, type) {
      let files = type === 'click' ? event.target.files || event.srcElement.files : event.dataTransfer.files
      let image = files[0]
      const isJPG = image.type === 'image/jpeg'
      const isGIF = image.type === 'image/gif'
      const isPNG = image.type === 'image/png'
      const isBMP = image.type === 'image/bmp'
      const isJPGS = image.type === 'image/jpg'
      if (!(isJPG || isBMP || isGIF || isPNG || isJPGS)) {
        this.$message.error('请上传正确格式的图片文件!（目前支持jpeg, gif, png, bmp, jpg）')
        document.getElementById('upload').value = null
        return
      }
      if (!((image.size / 1024 / 1024) < 5)) {
        this.$message.error('请上传大小小于5MB的图片!')
        document.getElementById('upload').value = null
        return
      }
      // 下面函数执行的效果是一样的，只是需要针对不同的浏览器执行不同的 js 函数而已
      if (window.createObjectURL !== undefined) { // basic
        this.uploadImage = window.createObjectURL(image)
      } else if (window.URL !== undefined) { // mozilla(firefox)
        this.uploadImage = window.URL.createObjectURL(image)
      } else if (window.webkitURL !== undefined) { // webkit or chrome
        this.uploadImage = window.webkitURL.createObjectURL(image)
      }
      // this.uploadImage = image
      this.formData = new FormData()
      this.formData.append('file', image)
      this.formData.append('endpoint', 'GTY_STORE')
    },
    handleDragenter (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    handleDragover (e) {
      e.stopPropagation()
      e.preventDefault()
    },
    handleDrop (e) {
      // 当文件拖拽到dropBox区域时,可以在该事件取到files
      this.uploadSearchImage(e, 'drop')
      e.preventDefault()
    },
    submitSearchUpload () {
      if (!this.formData || !this.formData.get('file')) {
        this.$message.error('请先上传图片后重试该操作！')
        return
      }
      window.imageForm = this.formData
      window.uploadImage = this.uploadImage
      if (this.$route.path.includes('search-by-image')) {
        this.searchByImage()
      } else {
        this.$router.push('/search-by-image')
      }
    },
    clearSearchImage () {
      this.uploadImage = ''
      this.formData = null
      delete window.imageForm
      delete window.uploadImage
      localStorage.removeItem('imageForm')
      if (!this.$route.path.includes('image-search')) {
        this.$router.push('/image-search')
      }
    },
    searchByImage () {
      this.formData = window.imageForm
      this.uploadImage = window.uploadImage
      if (!this.formData || !this.formData.get('file')) {
        this.$message.error('请先上传图片后再进行搜索！')
        return
      }
      this.$root.eventHub.$emit('search-by-image', this.formData)
    }
  }
}
</script>

<style lang="stylus" scoped>
.upload-box
  cursor pointer
  width 420px
  height 118px
  background #eceded
  border-radius 5px

.upload-text
  font-size 18px
  line-height 32px

.upload-tips
  color #999
  font-size 16px

.upload-image
  width auto
  height 100%
  object-fit contain

.submit-text
  cursor pointer
  padding-top 10px
  font-size 18px
  color #000
  margin 0px 10px
  &.clear
    color #bd2124
  &:hover
    opacity 0.8
</style>
